<script setup>
defineProps({
  title: String,
  subtitle: String,
  buttonText: String,
  buttonIcon: String,
  buttonColor: String,
});

defineEmits(["action"]);
</script>
<template>
  <div
    class="page-header d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-2"
  >
    <div>
      <h4 class="fw-bold mb-1 d-block d-lg-none">{{ title }}</h4>
      <p v-if="subtitle" class="text-muted mb-0">
        {{ subtitle }}
      </p>
    </div>

    <button
      v-if="buttonText"
      type="button"
      class="btn rounded-3 px-4 shadow-sm"
      :class="
        buttonColor
          ? `btn-outline-${buttonColor} border-${buttonColor}-subtle`
          : 'btn-outline-primary border-primary-subtle'
      "
      @click="$emit('action')"
    >
      <i v-if="buttonIcon" :class="`bi ${buttonIcon} me-1`"></i>{{ buttonText }}
    </button>
  </div>
</template>

<style scoped>
.page-header {
  min-height: 68px;
}
</style>
